module.exports = __webpack_public_path__ + "assets/img/menu_bg_4.92c814b9.png";